export enum HttpMethods {
  Post = 'post',
  Get = 'get',
  Patch = 'patch',
  Delete = 'delete',
  Put = 'put',
}
